import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If prerender.js (see scripts/prerender.js) pre-populated #root with static
// HTML at build time, hydrate that markup. Otherwise (dev / SSR-less deploy)
// mount fresh. This matches what react-snap did for legacy React, adapted
// for React 19's hydrateRoot API.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, <App />);
} else {
  ReactDOM.createRoot(container).render(<App />);
}
